<script setup>
import RecordVideoMenu from "@/components/main/recordVideo/recordVideoMenu/recordVideoMenu.vue";
import MoreButtonComponent from "@/components/common/button/moreButtonComponent.vue";
import {onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import axios from "@/axios";
import {useLanguageStore} from "@/pinia";
import {formatDate} from "@/plugins/dayjs";
const languageStore = useLanguageStore();
const router = useRouter();
const props = defineProps(['meetings'])
// mt000 최근회의, mt001위원회회의, mt002본회의
const menu = ref( 'mt000')
const currentAge =ref(21)
const meetingData = ref([])

const set_menu=(m)=>{
      menu.value = m
}
const selectMeeting=(meetingId)=> {
  console.log("select" + meetingId)
  router.push({
    name: 'detailRecord',
    params: {
      meetingId: meetingId
    }
  })
}
const getData = ()=>{
  axios.get("/api/meeting/current")
      .then(s=>{
        console.log(s)
        meetingData.value = s.data
      }).catch(e=>{
        console.log(e)
      })
}

onMounted(()=>{
  getData()
})


</script>

<template>
  <div class="recordVideoComponentArea">
    <div class="selectedMeetingStatus">
      <record-video-menu @set_menu="set_menu" :code-id="menu"></record-video-menu>
    </div>
    <div class="currentMeetingArea">
      <template v-if="menu == 'mt000'">
        <template v-if="meetingData.length >0">
          <div class="meeting" v-for="meeting in meetingData.slice(0,6)" :key="meeting.meetingId" @click="selectMeeting(meeting.meetingId)" >
            <div class="dateTime">
              <div class="meetingDate">
                {{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}
              </div>
              &nbsp;&nbsp;
              <div class="meetingTime">
                {{formatDate(meeting.meetingPreDt, 'HH:mm')}}
              </div>
            </div>
            <div class="meetingName">
              {{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}
            </div>
            <div class="thumbnail">
              <template v-if="meeting.thumbnailUrl != ''">
                <v-img
                    :src="meeting.thumbnailUrl"
                    cover
                ></v-img>
              </template>
              <div v-else class="notThumbnail">
                <v-icon
                    color="#052C65"
                    size="50"
                >mdi-play</v-icon>
              </div>

            </div>
          </div>
        </template>
        <template v-else>
          <div class="noData">
            {{languageStore.get('noMeeting')}}
          </div>
        </template>
      </template>
      <template v-else>
        <template v-if="meetingData.length >0">
          <template v-for="meeting in meetingData" :key="meeting.meetingId">
            <div class="meeting" v-if="meeting.meetingType.codeId == menu " @click="selectMeeting(meeting.meetingId)" >
              <div class="dateTime">
                <div class="meetingDate">
                  {{formatDate(meeting.meetingPreDt, 'YYYY-MM-DD')}}
                </div>
                &nbsp;&nbsp;
                <div class="meetingTime">
                  {{formatDate(meeting.meetingPreDt, 'HH:mm')}}
                </div>
              </div>
              <div class="meetingName">
                {{meeting.age.ageTitle}}_{{meeting.meetingType.codeNm}}
              </div>
              <template v-if="meeting.thumbnailUrl != ''">
                <div class="thumbnail">
                  <v-img
                      :src="meeting.thumbnailUrl"
                      cover
                  ></v-img>
                </div>
              </template>
              <div v-else class="notThumbnail">
                <v-icon
                    color="#052C65"
                    size="50"
                >mdi-play</v-icon>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="noData">
            {{languageStore.get('noMeeting')}}
          </div>
        </template>
      </template>
    </div>
    <div class="moreButtonArea">
      <more-button-component url="/record"></more-button-component>
    </div>
  </div>
</template>

<style scoped>
.recordVideoComponentArea{
  width: 90%;
  height: 80vh;
  background: white;
}
.selectedMeetingStatus{
  margin-left: 40px;
  padding : 20px;
}
.currentMeetingArea{
  display: grid;
  grid-template-columns: repeat(3,25vw);
  grid-template-rows: repeat(2,30vh);
  grid-gap: 10px;
  align-items: center;
  justify-content: center;
}
.meeting{
  background: #052C65;
  margin: 10px;
  width: 22vw;
  height: 29vh;
  border-radius: 4px;
  padding:20px;
  color: white;
  cursor: pointer;
}
.meeting:hover {
  background: #0d2881 ;
  margin: 10px;
  width: 22vw;
  height: 29vh;
  border-radius: 4px;
  padding:20px;
  color: white;
  border: 1px solid #c7c7c7;
}
.meeting div{
  margin-bottom: 4px;
}

.dateTime{
  display: flex;
  color: #C0E1FF;
}
.meetingName{
  font-size: 1.3rem;
  font-weight: bold;
}
.moreButtonArea{
  margin: 20px 20px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.thumbnail{
  width : 20vw;
  height: 18vh;
  border-radius: 20px;
}
.notThumbnail{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  height: 18vh;
  border-radius: 20px;

}
.noData{
  display: flex;
  align-items: center;
  justify-content: center;
  color: #90A4AE;
  font-size: 14px;
  grid-column: 1 / -1;
  padding: 40px;
}
</style>